import { Loader2 } from "lucide-react";

export default function ModernLoader({
  title = "Loading",
  subtitle = "Please wait while we prepare your workspace",
  fullScreen = false,
  compact = false,
}) {
  const wrapperClass = fullScreen
    ? "min-h-screen"
    : compact
      ? "py-10"
      : "py-16";

  return (
    <div className={`${wrapperClass} flex items-center justify-center`}>
      <div className="relative w-full max-w-sm px-4">
        <div className="erp-loader-panel rounded-2xl border border-slate-200 bg-white/95 backdrop-blur px-5 py-6 shadow-xl">
          <div className="flex items-center gap-3">
            <div className="relative h-11 w-11 shrink-0 rounded-xl erp-gradient overflow-hidden">
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_25%_20%,rgba(255,255,255,0.35),transparent_45%)]" />
              <div className="absolute inset-0 flex items-center justify-center">
                <Loader2 className="h-5 w-5 animate-spin text-white" />
              </div>
            </div>
            <div>
              <div className="text-sm font-semibold text-slate-800">
                {title}
              </div>
              <div className="text-xs text-slate-500">{subtitle}</div>
            </div>
          </div>
          <div className="mt-4 h-1.5 rounded-full bg-slate-100 overflow-hidden">
            <div className="erp-loader-progress h-full rounded-full" />
          </div>
        </div>
      </div>
    </div>
  );
}
